import { useState } from 'react';

const faqs = [
  {
    question: '新有菜的蔬菜是从哪里来的？',
    answer: '新有菜与全国500多个优质蔬菜产地建立了直供合作关系，包括山东寿光、河北张家口、云南昆明、浙江庆元等知名蔬菜产区。我们严格筛选合作基地，确保每一份蔬菜都来自可追溯的优质产地。',
  },
  {
    question: '下单后多久能收到蔬菜？',
    answer: '我们采用"今日下单、次日清晨采摘、当日配送"的模式。每天凌晨4点开始采摘，上午完成分拣包装，下午开始配送。大部分地区在当天下午至傍晚即可收到新鲜的蔬菜。具体送达时间会根据您的地址和下单时间有所不同。',
  },
  {
    question: '如何保证蔬菜的新鲜度？',
    answer: '我们从多个环节保障新鲜度：1）精准采摘，按订单量采摘，减少库存时间；2）严格分拣，只保留品质最好的蔬菜；3）专业包装，根据蔬菜特性采用不同包装方式；4）全程冷链，从采摘到配送保持2-8°C恒温。',
  },
  {
    question: '收到蔬菜不满意怎么办？',
    answer: '我们承诺品质问题无条件退换。如果您收到的蔬菜有任何品质问题，请在收到后24小时内联系客服，我们会为您安排退款或重新配送。您的满意是我们的首要目标。',
  },
  {
    question: '新有菜支持哪些支付方式？',
    answer: '目前支持微信支付和支付宝支付，后续将陆续开通更多支付方式，为您提供便捷的支付体验。',
  },
  {
    question: '可以为企业或餐厅提供批量配送吗？',
    answer: '当然可以！新有菜为餐饮企业提供专属的批量采购服务，包括定制化的蔬菜品类组合、更优惠的批发价格和更灵活的配送方案。欢迎联系我们的商务团队了解更多详情。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-100" aria-labelledby="faq-heading">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-50 text-primary-700 text-xs font-medium rounded-full mb-4">
            常见问题
          </span>
          <h3 id="faq-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            您关心的问题，这里都有答案
          </h3>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-100 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 animate-[fadeIn_200ms_ease-out]">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}